import type { FaireProductEntity } from "../../entity_types/product";

export const p_qqs8tj47at: FaireProductEntity = {
  token: "p_qqs8tj47at",
  type: "product",
  name: "Set of 4 Succulent Magnets",
  brandToken: "b_x9gc7rccbx",
  brandName: "Mars & Me",
  imageUrl:
    "https://cdn.faire.com/fastly/27f20dd38df38dd3b06b79eb280ba52213859c9ca03ba704c991477cd0ffb930.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.63,
  description:
    "Experience a touch of nature with Mars & Me's Set of 4 Succulent Magnets. Each piece in this set is meticulously hand-painted, capturing the unique beauty of succulents. Laser-cut for precision, these magnets offer an aesthetic appeal that is both charming and refreshing. Whether adorning your fridge or workspace, they bring a pop of color and whimsy to your surroundings. A product of a woman-owned, family-operated business from Louisville, KY, these magnets are a testament to quality and creativity.",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:33.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
